import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 0,
  class: "modal-message"
}
const _hoisted_7 = { class: "modal-footer" }

import { ref, computed } from 'vue';
    import { QuillEditor } from '@vueup/vue-quill';
    import '@vueup/vue-quill/dist/vue-quill.snow.css';
    import AQButton from '@/components/shared/forms/inputs/AQButton.vue';
    import AQCheckBox from '@/components/shared/forms/inputs/AQCheckBox.vue';

    interface Props {
        show?: boolean;
        title?: string;
        message?: string;
        isReleaseNote?: boolean;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MessageModal',
  props: {
    show: { type: Boolean, default: false },
    title: { default: '' },
    message: { default: 'Default Message' },
    isReleaseNote: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const dontShowAgain = ref(false);
    const editorContent = computed(() => props.message);

    const closeModal = () => {
        emit('close', dontShowAgain.value);
    };

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!

  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(__props.title), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (!__props.isReleaseNote)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.message), 1))
              : (_openBlock(), _createBlock(_unref(QuillEditor), {
                  key: 1,
                  content: editorContent.value,
                  readOnly: true,
                  options: { modules: { toolbar: false } },
                  contentType: "html",
                  theme: "snow"
                }, null, 8, ["content"]))
          ]),
          _createElementVNode("div", _hoisted_7, [
            (__props.isReleaseNote)
              ? (_openBlock(), _createBlock(AQCheckBox, {
                  key: 0,
                  modelValue: dontShowAgain.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dontShowAgain).value = $event)),
                  label: _ctx.$t('forms.labels.dontShowAgain'),
                  "hide-details": "",
                  class: "dont-show-checkbox"
                }, null, 8, ["modelValue", "label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_spacer),
            _createVNode(AQButton, {
              variant: "flat",
              color: "secondary",
              onClick: closeModal
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.isReleaseNote ? _ctx.$t('forms.btn.close') : _ctx.$t('forceUpdate.continue')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})